  import Vue from 'vue'
  let vm = new Vue()
  export default vm


// WEBPACK FOOTER //
// ./src/services/tabbar/channel.js